import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { useProfile } from '@contexts/ProfileContext';
import type { ProfileFeatures } from '@/types/planning';

/** Tela amigável quando o módulo não está liberado para o usuário (o backend devolve 403). */
export const ModuleNotEnabled: React.FC<{ module?: string }> = ({ module = 'Acervo CAC' }) => (
  <div className="flex items-center justify-center py-24 px-4">
    <div className="text-center max-w-md">
      <ShieldOff size={48} className="text-slate-300 mx-auto mb-4" />
      <h2 className="text-xl font-semibold text-slate-700 mb-2">Módulo não liberado</h2>
      <p className="text-slate-500">
        O módulo <strong>{module}</strong> não está liberado para o seu usuário. Peça ao administrador para liberar em
        Administração → Usuários (ou para todos, em Configurações).
      </p>
      <Link to="/" className="inline-block mt-4 text-sm text-emerald-700 hover:underline">
        Voltar para Hoje
      </Link>
    </div>
  </div>
);

interface FeatureGuardProps {
  feature: keyof ProfileFeatures;
  children: React.ReactNode;
}

/**
 * Protege uma rota por módulo liberado (`features` do /auth/profile). Enquanto o perfil carrega,
 * mostra um esqueleto para não negar de forma falsa.
 */
export const FeatureGuard: React.FC<FeatureGuardProps> = ({ feature, children }) => {
  const { features, isLoading } = useProfile();
  if (isLoading) return <div className="animate-pulse bg-slate-200 rounded h-4 w-16" />;
  if (!features[feature]) return <ModuleNotEnabled />;
  return <>{children}</>;
};
